import '.gh{height:2rem;}.ssr-plugin'
import { Title } from '@app/components/core/typography/Title'
import Column from '@app/components/layout/Column'
import { RegionStatusRow } from './blocks/RegionStatusRow'
import { AvatarStack, AvatarStackProps } from '../avatarStack/AvatarStack'
import { Badge } from '@app/components/core/badge/Badge'
import Row from '@app/components/layout/Row'
import { Text } from '@app/components/core/typography/Text'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { CardWrapper } from './CardWrapper'
import { styled } from 'inlines'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLock } from '@fortawesome/pro-solid-svg-icons'
import { useQuery } from '@based/sdk/react'

export type MunicipalityCardPros = {
  id: number
  title: string
  avatar?: string
  hasBadge?: boolean
  isLocked?: boolean
  description?: string
  plots?: number
  initiatives: number
  onClick?: () => void
} & Pick<AvatarStackProps, 'avatars'>

export const MunicipalityCard = ({
  id,
  title,
  avatar,
  hasBadge = false,
  isLocked,
  description,
  plots,
  initiatives,
  avatars,
  onClick,
}: MunicipalityCardPros) => {
  const followerCountQuery = useQuery('count-followers', {
    entityType: 'municipality',
    entityIds: [id],
  })

  return (
    <CardWrapper
      onClick={onClick}
      style={{
        overflow: 'hidden',
        display: 'flex',
        border: 'var(--blue-border)',
        '&:hover': {
          border: '1px solid var(--primary-blue)',
        },
      }}
    >
      <Column
        style={{
          justifyContent: 'space-between',
          minHeight: '16rem',
          width: '100%',
        }}
      >
        <Column
          gap="0.5rem"
          alignItems="stretch"
          style={{
            width: '100%',
          }}
        >
          <Row
            style={{
              justifyContent: 'space-between',
            }}
          >
            <Avatar
              size="small"
              variant="yellow"
              shape="square"
              image={avatar}
              labelSource={title}
            />
            {isLocked && (
              <FontAwesomeIcon
                icon={faLock}
                style={{
                  color: 'var(--shades-blue-400)',
                  height: '1rem',
                }}
              />
            )}
          </Row>
          <Row
            gap="0.25rem"
            style={{ width: '100%', alignItems: 'center', alignSelf: 'start' }}
          >
            <Title.H4
              style={{
                minWidth: 0,
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                margin: 0,
              }}
            >
              {title}
            </Title.H4>
            {hasBadge && <Badge />}
          </Row>
          {description && (
            <Text.Small
              style={{
                color: 'var(--shades-blue-500)',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
              }}
            >
              {description}
            </Text.Small>
          )}
        </Column>
        <Column gap="1.5rem" style={{ justifyContent: 'end' }}>
          <RegionStatusRow
            initiatives={initiatives}
            plots={plots}
            isLocked={isLocked}
          />
          <div className="gh">
            <AvatarStack
              size={'extra-small'}
              avatars={avatars}
              total={followerCountQuery.data?.[0] ?? 0}
            />
          </div>
        </Column>
      </Column>
    </CardWrapper>
  )
}
